import { CONFIG } from "~/config";

interface IJson {
	link: string;
	error: string;
}

interface IGetBookingLink {
	source?: string;
	origin?: string;
	lon: number;
	lat: number;
}

export async function getBookingLink({
	source,
	origin,
	lon,
	lat,
}: IGetBookingLink): Promise<IJson> {
	const searchPath = new URLSearchParams();

	searchPath.append("lon", lon.toFixed(5));
	searchPath.append("lat", lat.toFixed(5));

	if (source) {
		const dataSource = source === "osm" && origin
			? `${source}-${origin}`
			: source;

		searchPath.append("source", dataSource);
	}

	try {
		const response = await fetch(`${CONFIG.requestUrl}/booking-link/v1/get-link/?${searchPath.toString()}`);
		const json = await response.json() as IJson;

		if (response.status >= 200 && response.status < 300) {
			return json;
		}

		return {
			link: "",
			error: `Wrong status ${response.status}`,
		};
	} catch (exc) {
		/* eslint-disable-next-line */
		console.log(exc);

		return {
			link: "",
			error: "getBookingLink exception",
		};
	}
}
